import { motion } from "framer-motion";
import { Star, Quote, MapPin } from "lucide-react";
import { fadeInUp, staggerContainer } from "@/lib/constants";

const testimonials = [
  {
    quote: "Brunswick Glass transformed our bathroom with a stunning custom shower enclosure. The team was professional, efficient, and the result is beautiful.",
    author: "Sarah M.",
    location: "Wilmington, NC",
    rating: 5
  },
  {
    quote: "We needed to replace a broken storefront window quickly, and Brunswick Glass came through. They were fast, affordable, and minimized disruption to our business.",
    author: "James R.",
    location: "Southport, NC",
    rating: 5
  },
  {
    quote: "The window glass replacement service was excellent. Our fogged windows are now crystal clear, and our home is more comfortable.",
    author: "Linda C.",
    location: "Oak Island, NC",
    rating: 5
  },
];

const StarRating = () => (
  <div className="flex gap-1 mb-4">
    <Star className="w-5 h-5 text-[#D4AF37] fill-current" />
    <Star className="w-5 h-5 text-[#D4AF37] fill-current" />
    <Star className="w-5 h-5 text-[#D4AF37] fill-current" />
    <Star className="w-5 h-5 text-[#D4AF37] fill-current" />
    <Star className="w-5 h-5 text-[#D4AF37] fill-current" />
  </div>
);

const TestimonialCard = ({ testimonial, index }) => (
  <motion.div
    variants={fadeInUp}
    data-testid={`testimonial-card-${index}`}
    className="bg-[#F9F9F7] p-8 relative group hover:shadow-lg transition-shadow duration-300"
  >
    <Quote className="w-10 h-10 text-[#0F4C81]/20 mb-4" />
    <StarRating />
    <p className="font-body text-[#4B5563] leading-relaxed mb-6">
      "{testimonial.quote}"
    </p>
    <div>
      <div className="font-heading text-lg font-medium text-[#1A202C]">
        {testimonial.author}
      </div>
      <div className="font-body text-sm text-[#4B5563] flex items-center gap-1">
        <MapPin className="w-4 h-4" />
        {testimonial.location}
      </div>
    </div>
  </motion.div>
);

const TestimonialsSection = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="section-spacing bg-white">
      <div className="section-container">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
          className="text-center mb-10"
        >
          <motion.span
            variants={fadeInUp}
            className="inline-block font-accent text-sm font-semibold tracking-widest uppercase text-[#0F4C81] mb-4"
          >
            Testimonials
          </motion.span>
          <motion.h2
            variants={fadeInUp}
            className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-[#1A202C]"
          >
            What Our Clients Say
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          variants={staggerContainer}
          className="grid md:grid-cols-3 gap-6"
        >
          <TestimonialCard testimonial={testimonials[0]} index={0} />
          <TestimonialCard testimonial={testimonials[1]} index={1} />
          <TestimonialCard testimonial={testimonials[2]} index={2} />
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
